import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { LevelTableColumn } from 'redesign';
import { TableCell, TableHeader } from 'redesign';
import { ServiceAgreementState } from '@levelworks/shared-domain-types';
import { getServiceAgreementStateLabel } from '../../../shared/helpers/get-service-agreement-state-label';

export const useServiceAgreementsColumnDefinition = (): Record<
  'name' | 'state',
  LevelTableColumn<{ id: string; name: string; state: ServiceAgreementState }>
> => {
  const { t } = useTranslation(['ogp-screen-specific', 'all-platforms-common']);

  return useMemo(
    () => ({
      name: {
        accessor: 'name',
        Header: () => (
          <TableHeader>
            {t('flexpools.external.service_agreements_table.service_agreements', {
              ns: 'ogp-screen-specific',
            })}
          </TableHeader>
        ),
        Cell: ({ value }) => <TableCell>{value}</TableCell>,
      },
      state: {
        accessor: 'state',
        Header: () => (
          <TableHeader>
            {t('flexpools.external.service_agreements_table.state', { ns: 'ogp-screen-specific' })}
          </TableHeader>
        ),
        Cell: ({ value }) => {
          const { key, ns } = getServiceAgreementStateLabel(value);
          return <TableCell>{t(key, { ns })}</TableCell>;
        },
      },
    }),
    [t]
  );
};
